"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pain6 = exports.pain11Full = exports.pain11Partial = exports.happiness10 = exports.happiness7 = exports.happiness5 = void 0;
exports.happiness5 = [
    {
        value: 1,
        icon: "happiness-10-0",
        iconSelected: "happiness-10-0-solid",
        label: "dissatisfied"
    },
    {
        value: 2,
        icon: "happiness-10-2",
        iconSelected: "happiness-10-2-solid",
        label: "somewhat dissatisfied"
    },
    {
        value: 3,
        icon: "happiness-10-4",
        iconSelected: "happiness-10-4-solid",
        label: "neither satisfied nor dissatisfied"
    },
    {
        value: 4,
        icon: "happiness-10-7",
        iconSelected: "happiness-10-7-solid",
        label: "somewhat satisfied"
    },
    {
        value: 5,
        icon: "happiness-10-10",
        iconSelected: "happiness-10-10-solid",
        label: "extremely satisfied"
    }
];
exports.happiness7 = [
    {
        value: 1,
        icon: "happiness-10-0",
        iconSelected: "happiness-10-0-solid",
        label: "dissatisfied"
    },
    {
        value: 2
    },
    {
        value: 3,
        icon: "happiness-10-2",
        iconSelected: "happiness-10-2-solid",
        label: "somewhat dissatisfied"
    },
    {
        value: 4,
        icon: "happiness-10-5",
        iconSelected: "happiness-10-5-solid",
        label: "neither satisfied nor dissatisfied"
    },
    {
        value: 5,
        icon: "happiness-10-7",
        iconSelected: "happiness-10-7-solid",
        label: "somewhat satisfied"
    },
    {
        value: 6
    },
    {
        value: 7,
        icon: "happiness-10-10",
        iconSelected: "happiness-10-10-solid",
        label: "extremely satisfied"
    }
];
exports.happiness10 = [
    {
        value: 0,
        icon: "happiness-10-0",
        iconSelected: "happiness-10-0-solid",
        label: "extremely dissatisfied"
    },
    {
        value: 1,
        icon: "happiness-10-1",
        iconSelected: "happiness-10-1-solid"
    },
    {
        value: 2,
        icon: "happiness-10-2",
        iconSelected: "happiness-10-2-solid"
    },
    {
        value: 3,
        icon: "happiness-10-3",
        iconSelected: "happiness-10-3-solid"
    },
    {
        value: 4,
        icon: "happiness-10-4",
        iconSelected: "happiness-10-4-solid"
    },
    {
        value: 5,
        icon: "happiness-10-5",
        iconSelected: "happiness-10-5-solid",
        label: "neither satisfied nor dissatisfied"
    },
    {
        value: 6,
        icon: "happiness-10-6",
        iconSelected: "happiness-10-6-solid"
    },
    {
        value: 7,
        icon: "happiness-10-7",
        iconSelected: "happiness-10-7-solid"
    },
    {
        value: 8,
        icon: "happiness-10-8",
        iconSelected: "happiness-10-8-solid"
    },
    {
        value: 9,
        icon: "happiness-10-9",
        iconSelected: "happiness-10-9-solid"
    },
    {
        value: 10,
        icon: "happiness-10-10",
        iconSelected: "happiness-10-10-solid",
        label: "extremely satisfied"
    }
];
exports.pain11Partial = [
    {
        value: 0,
        icon: "pain-10-0",
        iconSelected: "pain-10-0-solid",
        label: "No Pain"
    },
    {
        value: 1
    },
    {
        value: 2,
        icon: "pain-10-2",
        iconSelected: "pain-10-2-solid",
        label: "Mild"
    },
    {
        value: 3
    },
    {
        value: 4,
        icon: "pain-10-4",
        iconSelected: "pain-10-4-solid",
        label: "Moderate"
    },
    {
        value: 5
    },
    {
        value: 6,
        icon: "pain-10-6",
        iconSelected: "pain-10-6-solid",
        label: "Severe"
    },
    {
        value: 7
    },
    {
        value: 8,
        icon: "pain-10-8",
        iconSelected: "pain-10-8-solid",
        label: "Very Severe"
    },
    {
        value: 9
    },
    {
        value: 10,
        icon: "pain-10-10",
        iconSelected: "pain-10-10-solid",
        label: "Worst Pain Possible"
    }
];
exports.pain11Full = [
    {
        value: 0,
        icon: "pain-10-0",
        iconSelected: "pain-10-0-solid",
        label: "No Pain"
    },
    {
        value: 1,
        icon: "pain-10-1",
        iconSelected: "pain-10-1-solid"
    },
    {
        value: 2,
        icon: "pain-10-2",
        iconSelected: "pain-10-2-solid",
        label: "Mild"
    },
    {
        value: 3,
        icon: "pain-10-3",
        iconSelected: "pain-10-3-solid"
    },
    {
        value: 4,
        icon: "pain-10-4",
        iconSelected: "pain-10-4-solid",
        label: "Moderate"
    },
    {
        value: 5,
        icon: "pain-10-5",
        iconSelected: "pain-10-5-solid"
    },
    {
        value: 6,
        icon: "pain-10-6",
        iconSelected: "pain-10-6-solid",
        label: "Severe"
    },
    {
        value: 7,
        icon: "pain-10-7",
        iconSelected: "pain-10-7-solid"
    },
    {
        value: 8,
        icon: "pain-10-8",
        iconSelected: "pain-10-8-solid",
        label: "Very Severe"
    },
    {
        value: 9,
        icon: "pain-10-9",
        iconSelected: "pain-10-9-solid"
    },
    {
        value: 10,
        icon: "pain-10-10",
        iconSelected: "pain-10-10-solid",
        label: "Worst Pain Possible"
    }
];
exports.pain6 = [
    {
        value: 0,
        icon: "pain-10-0",
        iconSelected: "pain-10-0-solid",
        label: "No Pain"
    },
    {
        value: 2,
        icon: "pain-10-2",
        iconSelected: "pain-10-2-solid",
        label: "Mild"
    },
    {
        value: 4,
        icon: "pain-10-4",
        iconSelected: "pain-10-4-solid",
        label: "Moderate"
    },
    {
        value: 6,
        icon: "pain-10-6",
        iconSelected: "pain-10-6-solid",
        label: "Severe"
    },
    {
        value: 8,
        icon: "pain-10-8",
        iconSelected: "pain-10-8-solid",
        label: "Very Severe"
    },
    {
        value: 10,
        icon: "pain-10-10",
        iconSelected: "pain-10-10-solid",
        label: "Worst Pain Possible"
    }
];
//# sourceMappingURL=predeterminedScales.js.map